module.exports = __webpack_public_path__ + "static/media/header-back.64ec260d.jpg";